export default __webpack_public_path__ + "static/media/survey-red.b796e6e9.png";